import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LocaldataService } from '../../service/localdata/localdata.service';

@Component({
  selector: 'app-breadcrumb-vejebon',
  templateUrl: './breadcrumb-vejebon.component.html',
  styleUrls: ['./breadcrumb-vejebon.component.scss'],
})
export class BreadcrumbVejebonComponent implements OnInit {
  private paramsObject: any;
  private serialnumber: any = '';
  constructor(private localData: LocaldataService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit() {
    this.route.queryParamMap
    .subscribe((params) => {
      this.paramsObject = { ...params.keys, ...params };
    })
    this.serialnumber = this.paramsObject.params.serialnumber;
  };


    
  

  backToHomepage() {
    this.router.navigate(['/asb/home']);
  }

  navigateBreadcrumbRoot(){
    this.localData.breadcrumb.splice(0,this.localData.breadcrumb.length);
    this.router.navigate(['vejeboner']) ;
  }

  navigateBreadcrumb(obj){    const arrayObj = this.localData.breadcrumb.findIndex(x => x.id === obj.id)+1;
    this.localData.breadcrumb.splice(arrayObj,this.localData.breadcrumb.length);
    this.router.navigate(['vejebon', obj.id]) ;
  }

}